import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Result, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

const ServerError = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    // 倒數計時
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/home");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleBackToHome = () => {
    navigate("/home");
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen"
      style={{ background: "#000", color: "#FFF" }}
    >
      <Result
        status="error"
        icon={<CloseCircleOutlined style={{ color: "#ff4d4f" }} />}
        title={
          <span style={{ color: "#FFF", fontSize: "24px" }}>
            頁面目前更新中，最多進行20分鐘...
          </span>
        }
        subTitle={
          <div style={{ color: "#9D9D9D", fontSize: "16px" }}>
            <p>請稍後再回來:)</p>
            <p className="mt-4">
              將在
              <span style={{ color: "#FFF", fontWeight: "bold" }}>
                {countdown}
              </span>
              秒後自動返回首頁...
            </p>
          </div>
        }
        extra={[
          <Button
            type="primary"
            key="home"
            size="large"
            onClick={handleBackToHome}
            style={{
              background: "#97c618",
              borderColor: "#97c618",
              color: "#000",
              fontWeight: "bold",
            }}
            className="hover:bg-opacity-90"
          >
            立即返回首頁
          </Button>,
        ]}
      />
    </div>
  );
};

export default ServerError;
